import axios, { AxiosResponse } from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";
import { ragUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";

export const postMessageFeedbackUseCase = async (
  namespace: string | null,
  messageId: string,
  useful: boolean,
): Promise<AxiosResponse | null> => {
  if (!namespace) {
    return null;
  }

  try {
    const url = `${ragUrlEnvVar()}/api/v1/ns/${namespace}/messages/${messageId}/useful`;
    return await axios.post(
      url,
      { useful },
      { headers: buildAxiosAuthenticationHeaders() },
    );
  } catch (error) {
    console.error(
      `Error sending ${useful ? "positive" : "negative"} feedback:`,
      error,
    );
    return null;
  }
};
